import { render, staticRenderFns } from "./EducationList.vue?vue&type=template&id=2dcfa42e"
import script from "./EducationList.vue?vue&type=script&lang=js"
export * from "./EducationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports